import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { AppInjector } from 'src/app/app.module';
import { AbstractComponent, Attachment, AttachmentType, EditorAttachmentFile, Task, TaskAttachment, UnsavedCache } from 'src/app/shared';
import { AwsImg } from 'src/app/shared/_components/editor-content-editable/editor-html-view/editor-html-view.component';
import { EditorFormPayload } from 'src/app/shared/_components/editor-form/editor-form.component';
import { EditorUserMention } from 'src/app/shared/_components/editor/editor.component';
import { EditorModule } from 'src/app/shared/_components/x-editor/_models';
import { FileService } from 'src/app/site-management/document/_services/file.service';

@Component({
  selector: '',
  template: ''
})
export class BaseTaskDescriptionComponent extends AbstractComponent implements OnInit {
  @Input() task: Task;
  @Input() uploadId: number;
  @Input() canEdit = true;
  @Input() description: string;
  @Input() getUserPromise: (searchTerm: string) => Promise<EditorUserMention[]>;
  @Input() upload$: (file: File) => Observable<Attachment>;
  @Output() save: EventEmitter< { payload: EditorFormPayload, callback: () => void }> = new EventEmitter();
  @Output() cancel = new EventEmitter<void>();
  @Output() uploadAttachmentSuccess = new EventEmitter<boolean>(false);

  taskUploadType = AttachmentType.description;
  fileService: FileService = AppInjector.get(FileService);
  module = EditorModule.TASK;
  taskAttachments: TaskAttachment[] = [];

  get descriptionText() : string {
    return this.translateService.instant('Add a description...');
  }

  showEditor = false;
  placeholder = `<span class="placeholder">${this.descriptionText}</span>`;
  parsedHtml = '';
  awsImgs: AwsImg[] = [];
  unsavedCache!: UnsavedCache;
  currentUserKey!: string;
  currentTaskKey!: string;
  localDescription: string = null;

  valueCtrl = new UntypedFormControl();
  valueChanged = false;

  constructor(
    public translateService: TranslateService,
  ) {
    super();
  }

  ngOnInit() {}

  onCancel(emit: boolean = true) {
    this.showEditor = false;
    const payload: EditorFormPayload = {
      attachments: null,
      htmlString: null,
      selectedUserMention: null
    };
    this.parsedHtml = null;
    this.onChange(null);
    if (emit) {
      // this.valueCtrl.setValue(this.description);
      this.cancel.emit();
    }
  }

  onSave(payload: EditorFormPayload) {
    let htmlString = payload.htmlString;
    this.awsImgs.forEach(e => {
      htmlString = htmlString.replace(e.objectUrl, e.url);
    });

    this.save.emit({
      payload: {
        htmlString,
        attachments: payload.attachments.map(e => {
          return {
            name: e.name,
            url: e.url,
            type: 'Description',
          };
        }),
        selectedUserMention: payload.selectedUserMention,
      },
      callback: () => {
        this.parsedHtml = '';
        this.awsImgs = [];
        this.showEditor = false;
      }
    });
    // this.valueCtrl.setValue(payload.htmlString);
    this.onCancel(false);
  }

  onClickComment(event: any, html: HTMLElement) {
    if (event?.target?.nodeName === 'IMG' || !this.canEdit) {
      return;
    } else {
      this.showEditor = true;
    }
    this.checkUnsavedDescription();
  }

  onContentParsed(html: string, awsImgs: AwsImg[]) {
    this.parsedHtml = html;
    this.awsImgs = awsImgs;

    this.checkUnsavedDescription();
  }

  onChange(value: string) { }

  checkUnsavedDescription() {
    if (!isEmpty(this.unsavedCache)) {
      this.localDescription = this.unsavedCache?.[this.currentUserKey]?.[this.currentTaskKey]?.description;
      if (this.localDescription && this.description !== this.localDescription) {
        this.valueCtrl.setValue(this.localDescription);
        this.valueChanged = true;
      }
    }
  }

  onFileInserted(file: EditorAttachmentFile) {
    if (file) {
      this.uploadAttachmentSuccess.emit(true);
    }
  }
}
